export default {

    init: function () {
        this.bindEvents();
    },

    bindEvents: function () {
        $('.hero-single-slide').hover(() => {
            $('.hero-single-slide').removeClass('active');
        });
        $('.floating-cards-slide').hover(() => {
            $('.floating-cards-slide').removeClass('active');
        });

    },
};